import { mapState } from 'vuex'

export default {
  computed: {
    isActualEvent() {
      return this.event.id === this.actualEvent?.id
    },
    ...mapState('events', ['actualEvent']),
  },
}
